module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-abstract-kimberly-0.c28420ef.jpg";